import { createRoot } from "react-dom/client";

import { App } from "./app";
import "./index.css";
import { getUserPreferences } from "./lib/user-preferences";

// Ensure the correct theme class is applied to <html> before React renders
(() => {
  try {
    const { theme } = getUserPreferences();

    const prefersDark = window.matchMedia(`(prefers-color-scheme: dark)`).matches;
    const useDark = theme === `dark` || (theme === `auto` && prefersDark);

    const root = window.document.documentElement;

    root.classList.remove(`dark`);

    if (useDark) {
      root.classList.add(`dark`);
    }
  } catch {
    // ignore
  }
})();

const documentRoot = document.getElementById(`root`);

if (!documentRoot) {
  throw new Error(`Failed to find the root element`);
}

createRoot(documentRoot).render(<App />);
